(async()=>{var t=await import(window.theme.modules.baseComponent);customElements.define("main-nav",class extends t.default{elements={dropdowns:"*[data-dropdown]"};modalInit=!1;render(){this.$dropdowns.filter(t=>t.hasAttribute("data-offset-drop")).map(t=>{var e=t.getBoundingClientRect();document.documentElement.clientWidth-e.x+e.width<600&&t.classList.add("@drop-reverse")})}reRender(){this.closest("modal-popup")&&!this.modalInit&&(this.modalInit=!0,this.$dropdowns.map(t=>{t.addEventListener("click",t=>{t.preventDefault();t=t.currentTarget.dataset.dropdown;const e=this.querySelector(`[data-dropby="${t}"]`);e.classList.toggle("!active")})}))}})})();


jQuery(document).ready(function($) {

  $('.mymain-nav-item').not('.no-dropdown').on('click', function(e) {
    if ($(window).width() <= 699) {
      return; // skip click behavior on small screens
    }

    // only prevent default if the click is on the top-level link
    if ($(e.target).closest('a').parent().is(this)) {
      e.preventDefault();
    }

    $('.mymain-nav-dropdown').css({"transition": "none"});

    const $dropdown = $(this).find('.mymain-nav-dropdown');
    const isOpen = $dropdown.css("opacity") === "1";

    // Close all dropdowns first
    $('.mymain-nav-dropdown').css({
      "opacity": "0",
      "pointer-events": "none",
      "transform": "translateY(-10px)"
    });

    // If this one wasn’t already open, open it
    if (!isOpen) {
      $dropdown.css({
        "opacity": "1",
        "pointer-events": "auto",
        "transform": "translateY(0)"
      });
    }
  });

  // Close when clicking outside
  $(document).on('click', function(e) {
    if (
      $(window).width() > 699 &&
      !$(e.target).closest('.mymain-nav-item').length
    ) {
      $('.mymain-nav-dropdown').css({
        "opacity": "0",
        "pointer-events": "none",
        "transform": "translateY(-10px)"
      });
    }
  });

});
